import {ConfigurationGateway} from '../../../../core-logic/gateways/api-services/configuration-gateway';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ErrorModel} from '../../../../core-logic/models/shared/error-model';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../../environments/environment';
import {OptionPricingModel} from '../../../../core-logic/models/shared/option-pricing-model';
import {ChargeFeeModel} from '../../../../core-logic/models/shared/charge-fee-model';

@Injectable({providedIn: 'root'})
export class ConfigurationGatewayHttp implements ConfigurationGateway {
  constructor(private httpClient: HttpClient) {}

  getAppVersion(): Observable<string | ErrorModel> {
    return this.httpClient.get<string | ErrorModel>(`${environment.fydlApi.url}/api/public/app-version`);
  }

  getAppPricing(): Observable<OptionPricingModel[] | ErrorModel> {
    return this.httpClient
      .get<OptionPricingModel[] | ErrorModel>(`${environment.fydlApi.url}/api/public/app-pricing`);
  }

  getChargeFees(): Observable<ChargeFeeModel> {
    return this.httpClient
      .get<ChargeFeeModel>(`${environment.fydlApi.url}/api/public/charge-fees`);
  }
}
